import axios from "axios";

export default axios.create({
    //baseURL: 'https://cms.poorterhotel.nl/ns/',
    baseURL: 'https://cms.classactionverhuurderheffing.nl/ns',
    timeout: 10000,
});
